Ext.define('SA.Canvas', {
    singleton: true,

    async toBase64(canvas) {
        var dataUri = await this.toDataUri(canvas);

        return dataUri.slice(dataUri.indexOf(',') + 1);
    },

    toBlob(canvas) {
        return new Promise(resolve => canvas.toBlob(resolve));
    },

    toDataUri(canvas) {
        return this.toBlob(canvas).then(SA.Blob.toDataUri);
    }
});